<template>
  <router-view></router-view>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import {
  ACTION_DO_LOGOUT,
  GETTER_USER_INFO,
  ACTION_GET_USER_LOGIN_INFO,
  ACTION_UPDATE_USER_INFORMATION
} from "@/store/modules/users/constants";
import globalMessage from "./store/message";
import constants from "@/_consts";
import _ from "lodash";
import { EventBus } from "@/event-bus";
import {
  EVENT_TOAST_MESSAGE,
  EVENT_UPDATED_USER_TIME_ZONE
} from "@/store/events";
import timezone from "@/utils/const-timezones";
import moment from "moment";
import Auth from "@aws-amplify/auth";
import consts from "@/_consts";
import commonUtils from "@/utils/common";

export default {
  name: "app",
  mounted() {
    EventBus.$on('callRefreshToken', this.handleGetNewTokenWithRefreshToken);
  },
  computed: {
    isExternalUser() {
      return this.userInfo.roles
        && this.userInfo.roles.data
        && this.userInfo.roles.data.length
        && this.userInfo.roles.data[0].external;
    },
    ...mapGetters({
      userInfo: GETTER_USER_INFO
    })
  },
  methods: {
    handleUnAuthorizedToken() {
      sessionStorage.removeItem(constants.LOCAL_STORE.accessToken);
      sessionStorage.removeItem(constants.LOCAL_STORE.refreshToken);
      sessionStorage.removeItem(constants.LOCAL_STORE.uid);
      this.$modal.show("dialog", {
        title: globalMessage.dialog.unAuthorizedToken.title,
        text: globalMessage.dialog.unAuthorizedToken.msg,
        clickToClose: false,
        buttons: [
          {
            title: globalMessage.common.yes,
            handler: () => {
              this.$modal.hide("dialog");
              this.doLogout();
              this.$ga.set("userId", "N/A");
              this.$ga.set("role", "");
              this.$ga.set("employer_ids", "");
            }
          }
        ]
      });
    },
    handlePermissionDeny() {
      this.$modal.show("dialog", {
        title: globalMessage.dialog.noPermission.title,
        text: globalMessage.dialog.noPermission.msg,
        clickToClose: false,
        buttons: [
          {
            title: globalMessage.common.yes,
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    async handleGetNewTokenWithRefreshToken () {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
          const { idToken } = session;
          sessionStorage.setItem(
            consts.LOCAL_STORE.accessToken,
            `Bearer ${idToken.jwtToken}`
          );
          commonUtils.calculateAndStoreRefreshTimestamp(idToken);
        });
      } catch (e) {
        //If can not get new Token then:
        this.handleUnAuthorizedToken();
      }
    },
    onGetUserInfo(responseData) {
      if (responseData.is_block === 1) {
        this.doLogout();
        return;
      }
      this.$set(this.userInfo, 'roles', responseData.roles);
      this.handleClientManagement(this.$route);
    },
    handleClientManagement(route) {
      if (!this.userInfo || !this.userInfo.userId) {
        return;
      }
      const routeHasPanel = route.matched.find(
        record =>
          record &&
          record.meta.panel &&
          Object.keys(record.meta.panel).length > 0
      );
      if (
        routeHasPanel
      ) {
        if (routeHasPanel.meta.panel === constants.panels.client) {
          let clientSelected = localStorage.getItem(
            constants.LOCAL_STORE.client
          );
          if (clientSelected) {
            try {
              clientSelected = JSON.parse(clientSelected);
            } catch (err) {
              console.log('Get selectedClient error', err);
            }
          }
        } else {
          if (this.isExternalUser) {
            // External user
            this.$router.push({ name: this.$dashboardRoute.items.clientAdminHome.name });
          }
        }
      }
    },
    getUserInfo() {
      const userId = sessionStorage.getItem(constants.LOCAL_STORE.uid);
      if (userId) {
        const opts = {
          id: userId,
          callback: this.onGetUserInfo
        };
        return this.actionGetUserLoginInfo(opts);
      }
    },
    timezoneHandle() {
      const isAutoUpdateTimezone =
        this.userInfo.is_auto_update_timezone || false;
      if (isAutoUpdateTimezone) {
        const mappedTimezone = timezone.getTimezoneWithUTC();
        const currentTime = moment.now();
        const momentCurrentUtcOffset = moment.tz
          .zone(moment.tz.guess(true))
          .utcOffset(currentTime);
        if (
          _.isEmpty(this.userInfo.timezone) ||
          moment.tz.zone(this.userInfo.timezone).utcOffset(currentTime) !==
            momentCurrentUtcOffset
        ) {
          const newTimezone = mappedTimezone.find(
            item =>
              momentCurrentUtcOffset ===
              moment.tz.zone(item.value).utcOffset(currentTime)
          );
          this.updateUserInformation({
            id: this.userInfo.id,
            data: {
              timezone: newTimezone.value
            }
          }).then(
            EventBus.$emit(
              EVENT_TOAST_MESSAGE,
              "Your time zone automatically changed to " + newTimezone.label
            )
          );
        }
      }
    },
    ...mapActions({
      doLogout: ACTION_DO_LOGOUT,
      actionGetUserLoginInfo: ACTION_GET_USER_LOGIN_INFO,
      updateUserInformation: ACTION_UPDATE_USER_INFORMATION
    })
  },
  created() {
    axios.interceptors.response.use(
      response => {
        if (!_.isEmpty(response.headers.authorization)) {
          sessionStorage.setItem(
            constants.LOCAL_STORE.accessToken,
            `Bearer ${response.headers.authorization}`
          );
        }
        return response;
      },
      error => {
        // Handle token expired
        if (error.response) {
          if (error.response.status === 401) {
            this.handleUnAuthorizedToken();
          } else if (error.response.status === 403) {
            this.handlePermissionDeny();
          }
          return Promise.reject(error);
        }
        return Promise.reject(error);
      }
    );
    this.getUserInfo();
    this.handleClientManagement(this.$route);
    this.timezoneHandle();
    EventBus.$on(
      EVENT_UPDATED_USER_TIME_ZONE,
      function() {
        this.timezoneHandle();
      }.bind(this)
    );
  },
  watch: {
    $route: function(to) {
      this.handleClientManagement(to);
    }
  }
};
</script>
<style lang="scss">
// Import Main styles for this application
@import "~@/assets/styles/style";
</style>



// WEBPACK FOOTER //
// src/App.vue